import {
  PluginExperiencePageTargetingSchema_2024_05_05,
  PluginExperiencePageTargetingType_2024_05_05,
} from "./2024-05-05";

export const PluginExperiencePageTargetingSchema =
  PluginExperiencePageTargetingSchema_2024_05_05;
export type PluginExperiencePageTargetingType =
  PluginExperiencePageTargetingType_2024_05_05;
